import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
    btnSuccess: {
        backgroundColor: '#41B60B',
        color: '#FFF'
    },
    btnCancel: {
        backgroundColor: '#C62026',
        color: '#FFF'
    }
}))